export const APP_CONFIG = {
  brand: {
    logoPath: "/brand/logo-lockup.png",
    sidebarLockupPath: "/brand/logo-sidebar.png",
    iconPath: "/brand/logo-icon.png",
    name: "レシぽん",
    subtitle: "LINEで送るだけ、AIで経費管理",
  },
  tenantBrand: {
    name: "レシぽん",
    subtitle: "LINEで送るだけ、AIで経費管理",
    sidebarLogoPath: "/brand/logo-icon.png",
  },
  operatorBrand: {
    name: "レシぽん 運用",
    subtitle: "LINEで送るだけ、AIで経費管理",
  },
  product: {
    footerDisplayName: "レシぽん",
    copyrightStartYear: 2026,
  },
  support: {
    feedbackEnabled: true,
  },
} as const;

export function buildCopyrightText(
  currentYear = new Date().getFullYear(),
): string {
  const startYear = APP_CONFIG.product.copyrightStartYear;
  const yearRange =
    currentYear > startYear ? `${startYear}-${currentYear}` : `${startYear}`;
  return `© ${yearRange} ${APP_CONFIG.product.footerDisplayName}`;
}
